// extracted by mini-css-extract-plugin
module.exports = {"List":"_2UlBf","ListItem":"_3gJ1I","Amount":"_3PZd7","Expense":"fMNT7"};